/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Pga_MemberInputs */

const en_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Member · Iowa Section · Since 1983`)
};

const es_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembro de la PGA · Sección de Iowa · Desde 1983`)
};

const de_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-Mitglied · Sektion Iowa · Seit 1983`)
};

const zh_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA 会员 · 爱荷华州分部 · 自 1983 年起`)
};

const ar_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عضو PGA · قسم Iowa · منذ 1983`)
};

const fr_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membre de la PGA · Section de l’Iowa · Depuis 1983`)
};

const vi_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành viên PGA · Chi hội Iowa · Từ 1983`)
};

const sw_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwanachama wa PGA · Tawi la Iowa · Tangu 1983`)
};

const th_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมาชิก PGA · สาขาไอโอวา · ตั้งแต่ปี 1983`)
};

const bs_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Član PGA · Sekcija Iowa · Od 1983.`)
};

const ja_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA会員 · アイオワ・セクション · 1983年から`)
};

const ko_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA 회원 · Iowa 섹션 · 1983년부터`)
};

const pt_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro da PGA · Seção de Iowa · Desde 1983`)
};

const it_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro PGA · Sezione Iowa · Dal 1983`)
};

const sv_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-medlem · Iowasektionen · Sedan 1983`)
};

const nl_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-lid · Sectie Iowa · Sinds 1983`)
};

const da_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-medlem · Iowa-afdelingen · Siden 1983`)
};

const nb_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-medlem · Iowa-seksjonen · Siden 1983`)
};

const fi_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA:n jäsen · Iowan osasto · Vuodesta 1983`)
};

const pl_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Członek PGA · Sekcja Iowa · Od 1983`)
};

const ru_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Член PGA · Секция Iowa · С 1983 года`)
};

const tr_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Üyesi · Iowa Bölümü · 1983'ten beri`)
};

const hi_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA सदस्य · Iowa सेक्शन · 1983 से`)
};

const id_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota PGA · Seksi Iowa · Sejak 1983`)
};

const ms_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahli PGA · Seksyen Iowa · Sejak 1983`)
};

const cs_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Člen PGA · Sekce Iowa · Od roku 1983`)
};

const el_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μέλος της PGA · Τμήμα Iowa · Από το 1983`)
};

const he_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חבר PGA · סניף Iowa · מאז 1983`)
};

const af_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-lid · Iowa-afdeling · Sedert 1983`)
};

const hu_about_pga_member = /** @type {(inputs: About_Pga_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-tag · Iowa szekció · 1983 óta`)
};

/**
* | output |
* | --- |
* | "PGA Member · Iowa Section · Since 1983" |
*
* @param {About_Pga_MemberInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_pga_member = /** @type {((inputs?: About_Pga_MemberInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Pga_MemberInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_pga_member(inputs)
	if (locale === "de") return de_about_pga_member(inputs)
	if (locale === "zh") return zh_about_pga_member(inputs)
	if (locale === "ar") return ar_about_pga_member(inputs)
	if (locale === "fr") return fr_about_pga_member(inputs)
	if (locale === "vi") return vi_about_pga_member(inputs)
	if (locale === "sw") return sw_about_pga_member(inputs)
	if (locale === "th") return th_about_pga_member(inputs)
	if (locale === "bs") return bs_about_pga_member(inputs)
	if (locale === "ja") return ja_about_pga_member(inputs)
	if (locale === "ko") return ko_about_pga_member(inputs)
	if (locale === "pt") return pt_about_pga_member(inputs)
	if (locale === "it") return it_about_pga_member(inputs)
	if (locale === "sv") return sv_about_pga_member(inputs)
	if (locale === "nl") return nl_about_pga_member(inputs)
	if (locale === "da") return da_about_pga_member(inputs)
	if (locale === "nb") return nb_about_pga_member(inputs)
	if (locale === "fi") return fi_about_pga_member(inputs)
	if (locale === "pl") return pl_about_pga_member(inputs)
	if (locale === "ru") return ru_about_pga_member(inputs)
	if (locale === "tr") return tr_about_pga_member(inputs)
	if (locale === "hi") return hi_about_pga_member(inputs)
	if (locale === "id") return id_about_pga_member(inputs)
	if (locale === "ms") return ms_about_pga_member(inputs)
	if (locale === "cs") return cs_about_pga_member(inputs)
	if (locale === "el") return el_about_pga_member(inputs)
	if (locale === "he") return he_about_pga_member(inputs)
	if (locale === "af") return af_about_pga_member(inputs)
	if (locale === "hu") return hu_about_pga_member(inputs)
	return en_about_pga_member(inputs)
});